import {Component, Inject} from "@angular/core";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {find} from "lodash-es";
import {FelloVisitorVariables} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";

enum RemodeledLocationName {
  Kitchen = "Kitchen",
  Bathroom = "Bathroom",
  PartialBath = "PartialBath"
}

export interface RemodeledLocation {
  name: RemodeledLocationName;
  value: string;
  selected: boolean;
}

@Component({
  selector: "app-que-remodeled-locations",
  templateUrl: "./que-remodeled-locations.component.html",
  styleUrls: ["./que-remodeled-locations.component.scss"]
})
export class QueRemodeledLocationsComponent extends QuestionCardDirective {
  remodeledLocationOptions: RemodeledLocation[] = [
    {
      name: RemodeledLocationName.Kitchen,
      value: "Kitchen",
      selected: false
    },
    {
      name: RemodeledLocationName.Bathroom,
      value: "Primary Bathroom",
      selected: false
    }
  ];

  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    // TODO
    this.updateFieldValue(RemodeledLocationName.Kitchen, this.offerJourney.vars.kitchenRemodeled);
    this.updateFieldValue(RemodeledLocationName.Bathroom, this.offerJourney.vars.bathsRemodeled);
    if ((this.offerJourney.vars.baths ?? 0) + (this.offerJourney.vars.partialBaths ?? 0) > 1) {
      this.remodeledLocationOptions.push({
        name: RemodeledLocationName.PartialBath,
        value: "Additional Bathroom(s)",
        selected: false
      });
      this.updateFieldValue(RemodeledLocationName.PartialBath, this.offerJourney.vars.partialBathsRemodeled);
    }
  }

  updateFieldValue(fieldName: RemodeledLocationName, value?: boolean): void {
    if (value) {
      const field = find(this.remodeledLocationOptions, {name: fieldName})!;
      field.selected = value;
    }
  }

  getFieldValue(fieldName: RemodeledLocationName): boolean {
    const field = find(this.remodeledLocationOptions, {name: fieldName})!;
    return field.selected;
  }

  next(): void {
    const vars: FelloVisitorVariables = {
      // TODO
      kitchenRemodeled: this.getFieldValue(RemodeledLocationName.Kitchen),
      bathsRemodeled: this.getFieldValue(RemodeledLocationName.Bathroom)
    };
    if ((this.offerJourney.vars.baths ?? 0) + (this.offerJourney.vars.partialBaths ?? 0) > 1) {
      vars.partialBathsRemodeled = this.getFieldValue(RemodeledLocationName.PartialBath);
    }
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}
